<template lang="pug">
  .qrcode-styling(v-if="hasData")
    .qrcode-styling-canvas(ref="qrCode" :style="sizeStyle")
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import QRCodeStyling, {
} from 'qr-code-styling';
//import { Base64 } from 'js-base64';
import CapLogoImage from "./logo.json";

@Component({
  name: "QrcodeStyling"
})
export default class QrcodeStyling extends Vue {
  @Prop({default: ''})
  sourceData!: string

  @Prop({default: null})
  qrcodeStylingConfig!: Record<string, any> | null

  @Prop({default: false})
  logoWorking!: boolean

  @Prop({default: 300})
  size!: number

  get hasData() {
    return this.sourceData && this.sourceData.length > 0;
  }

  qrCode = new QRCodeStyling(this.config as any);

  @Watch('config')
  onOptionsChanged() {
    this.qrCode.update(this.config as any);
  }

  download(extension, filename = 'qr-code') {
    this.qrCode.download({
      name: filename,
      extension: extension
    });
  }

  mounted() {
    this.qrCode.append(this.$refs["qrCode"] as HTMLElement);
    this.qrCode.update(this.config as any);
  }

  get sizeStyle() {
    return {
      width: this.size + 'px',
      height: this.size + 'px'
    }
  }

  get defaultConfig() {
    return {
      width: this.size,
      height: this.size,
      type: "svg",
      margin: 0,
      //data: "https://www.facebook.com/",
      image: this.logoWorking ? 'data:image/svg+xml;base64,' + CapLogoImage.logoWorking : null, //"https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg",
      dotsOptions: {
        color: "#627f23", //93bb36
        type: "square"
      },
      backgroundOptions: {
        color: "#ffffff",
      },
      cornersSquareOptions: {
        "type": "extra-rounded",
        //"color": "#000000"
      },
      imageOptions: {
        hideBackgroundDots: true,
        crossOrigin: "anonymous",
        imageSize: 0.5,
        margin: 0
      },
      qrOptions: {typeNumber: "0", mode: "Byte", errorCorrectionLevel: "Q"}
    }
  }

  get config() {
    if (!this.qrcodeStylingConfig)
      return Object.assign(this.defaultConfig, {
        data: this.sourceData
      });

    return Object.assign(this.qrcodeStylingConfig, {
      data: this.sourceData
    });
  }


}
</script>

<style scoped lang="less">
.qrcode-styling-canvas {
  margin: 0; padding: 0;
}
</style>
